'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DeletePrompt = require('./components/DeletePrompt.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DeletePrompt).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/delete-prompt/index.js
// module id = 1285
// module chunks = 0